import React from "react";
import { FiArrowDownCircle, FiArrowUpCircle } from "react-icons/fi";
import getIcon from "../../utils/getIcon";

const LeadsStatistics = ({ leadSummary = [], permission }) => {
  const dataArray = Array.isArray(leadSummary) ? leadSummary : [];

  return (
    <>
      {dataArray.map((val, index) => {
        return (
          <div
            key={index}
            className="col-xxl-3 col-md-3 leads-report-card"
          >
            <div className="card stretch stretch-full">
              <div className="card-body">
                <div className="d-flex align-items-start justify-content-between">
                  <div className="d-flex gap-4 align-items-center">
                    <div className="avatar-text avatar-lg bg-gray-200 icon">
                      {getIcon("feather-shopping-bag", {
                        size: 24,
                        color: "blue",
                      })}
                    </div>
                    <div>
                      <div className="fs-4 fw-bold text-dark">
                        <span className="counter">{val?.TotalLeads ?? 0}</span>
                      </div>
                      <h3 className="fs-13 fw-semibold text-truncate-1-line">
                        {val?.LeadType ?? ""}
                      </h3>
                    </div>
                  </div>
                </div>

                <div className="pt-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="fs-12 fw-medium text-muted text-truncate-1-line"></div>
                    <div className="w-100 text-end">
                      <span className="fs-13 text-muted">
                        ₹{val?.TotalAmount ?? 0}
                      </span>
                    </div>
                  </div>

                  <div className="progress mt-2 ht-3">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{
                        width: `${(val?.TotalLeads ?? 0) * 10}%`,
                        backgroundColor: "#4caf50",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default LeadsStatistics;
